// Header.js
import React, { useState } from 'react';
import HotelList from '../List.js/List';
import './Header.css';
import searchIcon from './imgs/search.png';
import Hotel from '../List.js/defult';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [query, setQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = () => {
    if (query.trim()) {
      setSearchQuery(query); // 
    }
  };

  return (
    <>
    
      <nav className="navbar">
        <h1 className="logo">STAYFINDER</h1>
        <div className="search-box">
          <input
            type="text"
            placeholder="Search destinations"
            className="search-input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <button className="search-btn" onClick={handleSearch}>
            <img src={searchIcon} alt="Search" className="search-icon" />
          </button>

        </div>
        <Link
          to="/city"
          style={{
            marginLeft: '1rem',
            textDecoration: 'none',
            color: '#ff385c',
            fontWeight: 'bold',
          }}
        >
          Back
        </Link>
      </nav>
     
      <HotelList query={searchQuery} />
    </>
  );
};
